<template>
  <div class="home">
    <video autoplay loop muted playsinline poster="@/assets/back4.jpg">
      <source
        v-if="portrait"
        src="@/assets/videos/tkl_promo_mobile_final_nosound.mp4"
        type="video/mp4"
      />
      <source
        v-else
        src="@/assets/videos/tkl_promo_final_V2_nosound.mp4"
        type="video/mp4"
      />
    </video>
    <section class="hero-content" v-if="$route.params.archiveID == null">
      <h1>{{ $t("home.heroTitle") }}</h1>
      <p class="hero-subtitle">{{ $t("home.heroSubtitle") }}</p>
      <router-link to="/register-team" class="hero-cta">{{ $t("registerTeam.registerCta") }}</router-link>
    </section>
    <section class="meet-the-players" v-if="$route.params.archiveID == null">
      <h2>{{ $t("home.meetThePlayers") }}</h2>
      <HomeSearch
        @search-function="searchRedirect($event)"
      />
      <div class="featured-players">
        <FeaturedPlayer
          v-for="(item, index) in players"
          :key="index"
          :content="item"
        />
      </div>
    </section>

    <section class="about-section" v-if="$route.params.archiveID == null">
      <h2>{{ $t("home.aboutTitle") }}</h2>
      <p>{{ $t("home.aboutText") }}</p>
      <div class="features">
        <div class="feature">
          <h3>{{ $t("home.feature1Title") }}</h3>
          <p>{{ $t("home.feature1Text") }}</p>
        </div>
        <div class="feature">
          <h3>{{ $t("home.feature2Title") }}</h3>
          <p>{{ $t("home.feature2Text") }}</p>
        </div>
        <div class="feature">
          <h3>{{ $t("home.feature3Title") }}</h3>
          <p>{{ $t("home.feature3Text") }}</p>
        </div>
      </div>
    </section>

    <section class="home-faq" v-if="$route.params.archiveID == null">
      <h2>{{ $t("home.faqTitle") }}</h2>
      <div class="faq-list">
        <details class="faq-item" v-for="(item, i) in homeFaqItems" :key="i">
          <summary class="faq-q">{{ item.q }}</summary>
          <p class="faq-a">{{ item.a }}</p>
        </details>
      </div>
    </section>

    <div id="popup" class="overlay" v-if="promo">
      <div class="popup">
        <a class="close" id="close" @click="close">&times;</a>
        <a :href="link">
          <picture>
            <source
              :srcset="`${$bucketUrl}/images/promo/promo.webp`"
              type="image/webp"
            />
            <source
              :srcset="`${$bucketUrl}/images/promo/promo.png`"
              type="image/png"
            />
            <img :src="`${$bucketUrl}/images/promo/promo.png`" alt="The Kings League promotion" loading="lazy" />
          </picture>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import FeaturedPlayer from "@/components/home/FeaturedPlayer.vue";
import HomeSearch from "@/components/home/HomeSearch.vue";
import axios from "axios";
export default {
  name: "Home",
  components: {
    FeaturedPlayer,
    HomeSearch,
  },
  data() {
    return {
      players: [],
      portrait: null,
      promo: false,
      link: null,
    };
  },
  metaInfo() {
    return {
      title: this.$t("seo_metadata.home.title"),
      meta: [
        { vmid: "description", name: "description", content: this.$t("seo_metadata.home.description") },
        { vmid: "keywords", name: "keywords", content: this.$t("seo_metadata.keywords") },
        { vmid: "og:title", property: "og:title", content: this.$t("seo_metadata.home.title") },
        { vmid: "og:description", property: "og:description", content: this.$t("seo_metadata.home.description") },
        { vmid: "og:url", property: "og:url", content: "https://kingsleague.ca" },
        { vmid: "og:type", property: "og:type", content: "website"},
        { vmid: "twitter:title", name: "twitter:title", content: this.$t("seo_metadata.home.title") },
        { vmid: "twitter:description", name: "twitter:description", content: this.$t("seo_metadata.home.description") }
      ],
      link: [{ rel: "canonical", href: "https://kingsleague.ca" + this.$route.path }],
      script: [{
        type: "application/ld+json",
        json: {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": this.homeFaqItems.map(item => ({
            "@type": "Question",
            "name": item.q,
            "acceptedAnswer": { "@type": "Answer", "text": item.a }
          }))
        }
      }]
    };
  },
  computed: {
    homeFaqItems() {
      return [
        { q: this.$t("home.faq.q1"), a: this.$t("home.faq.a1") },
        { q: this.$t("home.faq.q2"), a: this.$t("home.faq.a2") },
        { q: this.$t("home.faq.q3"), a: this.$t("home.faq.a3") },
        { q: this.$t("home.faq.q4"), a: this.$t("home.faq.a4") },
      ];
    },
  },
  methods: {
    close() {
      var modal = document.getElementById("popup");
      modal.style.visibility = "hidden";
      sessionStorage.setItem("promo", false);
    },
    async searchRedirect(item) {
      if(item.First_Name){
        this.$router.push({ path: `/players/${item._id}` });
      }else{
        let league = await axios.get(this.$apiUrl + `/teams/${item._id}/current-league`);
        league.data.message 
        ? this.$router.push({ path: `/team/${item._id}`})
        : this.$router.push({ path: `/team/${item._id}/${league.data[0]._id}`});
      }
    }
  },
  created() {
    this.portrait = window.innerWidth / window.innerHeight < 1;
  },
  beforeMount() {
    axios.get(this.$apiUrl + "/promo/").then((res) => {
      if (sessionStorage.getItem("promo") === "false") {
        this.promo = false;
      } else {
        this.promo = res.data.Enabled;
      }
      if (res.data.Link != "") {
        this.link = res.data.Link;
      }
    });
  },
  mounted() {
    axios.get(this.$apiUrl + "/extra/random-player/3").then((res) => {
      this.players = res.data;
      this.$store.dispatch("pageLoad", false);
    });
  },
};
</script>
<style lang="scss" scoped>
@import "@/theme.scss";

video {
  width: calc(100% + 30px);
  height: 100vh;
  object-fit: cover;
  object-position: center center;
  margin: -15px -15px 0 -15px;

  video source {
    width: 100%;
    height: auto;
  }
}

.home {
  margin: 0 !important;
  margin-top: -$navbar-height !important;
  max-width: none !important;
}

.featured-players {
  display: flex;
  margin: 0 -7.5px 0 -7.5px;

  .featured-player {
    flex: 1;
  }
}

h2 {
  margin-bottom: 15px;
}

.hero-content {
  text-align: center;
  padding: 30px 15px 20px;
  max-width: $max-width;
  margin: 0 auto;

  h1 {
    @extend %font-bold;
    font-size: 32px;
    margin-bottom: 10px;
  }
  .hero-subtitle {
    font-size: 17px;
    color: #555;
    margin-bottom: 20px;
    line-height: 1.5;
  }
  .hero-cta {
    display: inline-block;
    background-color: $secondary;
    color: white;
    padding: 12px 30px;
    border-radius: 5px;
    text-decoration: none;
    font-size: 18px;
    @extend %font-bold;
    &:hover {
      opacity: 0.9;
    }
  }
}

.meet-the-players {
  padding-top: 15px;
  margin: 0 auto;
  max-width: $max-width;
}

.league-leaders {
  max-width: $max-width;
  margin: 0 auto;
  padding: 20px 15px 30px;

  h2 {
    @extend %font-bold;
    font-size: 24px;
    margin-bottom: 15px;
  }
}
.leaders-list {
  max-width: 500px;
}
.leader {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  &:hover {
    background: #f8f8f8;
  }
}
.leader-rank {
  @extend %font-bold;
  font-size: 20px;
  color: $primary;
  width: 35px;
  text-align: center;
}
.leader-name {
  flex: 1;
  font-size: 15px;
}
.leader-stat {
  @extend %font-bold;
  font-size: 15px;
  color: $secondary;
}
.view-all-link {
  display: inline-block;
  margin-top: 15px;
  color: $secondary;
  text-decoration: none;
  font-size: 15px;
  @extend %font-bold;
  &:hover {
    text-decoration: underline;
  }
}

.home-faq {
  max-width: $max-width;
  margin: 0 auto;
  padding: 0 15px 30px;

  h2 {
    @extend %font-bold;
    font-size: 24px;
    margin-bottom: 15px;
  }
}
.faq-list {
}
.faq-item {
  border-bottom: 1px solid #eee;
  &:first-child {
    border-top: 1px solid #eee;
  }
}
.faq-q {
  @extend %font-bold;
  font-size: 16px;
  padding: 15px 0;
  cursor: pointer;
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &::after {
    content: "+";
    font-size: 22px;
    color: #999;
    flex-shrink: 0;
    margin-left: 15px;
  }
  &::-webkit-details-marker {
    display: none;
  }
}
details[open] .faq-q::after {
  content: "−";
}
.faq-a {
  font-size: 15px;
  color: #555;
  line-height: 1.5;
  padding: 0 0 15px;
}

.about-section {
  max-width: $max-width;
  margin: 0 auto;
  padding: 30px 15px;

  h2 {
    @extend %font-bold;
    font-size: 24px;
    margin-bottom: 10px;
  }
  & > p {
    color: #555;
    line-height: 1.6;
    margin-bottom: 20px;
  }
}
.features {
  display: flex;
  gap: 20px;
}
.feature {
  flex: 1;
  background: #f8f8f8;
  padding: 20px;
  border-radius: 8px;

  h3 {
    @extend %font-bold;
    font-size: 18px;
    margin-bottom: 8px;
  }
  p {
    font-size: 15px;
    color: #555;
    line-height: 1.4;
  }
}
.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
  visibility: visible;
  opacity: 1;
  width: 100%;
}
.popup {
  border: 2px solid $primary;
  display: flex;
  z-index: 2000;
  flex-direction: column;
  align-items: center;
  margin: auto;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 8px;
  width: fit-content;
  max-width: 90vw;
  max-height: 80vh;
  position: relative;
  img {
    max-width: 90vw;
    max-height: 80vh;
  }
  h6 {
    font-size: 10px;
  }
}

.popup h2 {
  margin-top: 0;
  color: #333;
}

.popup .close {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 30px;
  font-weight: bold;
  text-decoration: none;
  color: rgb(255, 0, 0);
}

.popup .close:hover {
  cursor: pointer;
  color: rgba(255, 0, 0, 0.623);
}

@media only screen and (max-width: $mobile-breakpoint) {
  .featured-players {
    flex-direction: column;
  }
  .features {
    flex-direction: column;
  }
  .hero-content h1 {
    font-size: 24px;
  }
}
</style>
